export const rules = (ctx) => {
  return {
    parkCompany: { required: true, message: '请输入园区公园', trigger: 'blur' },
    businessDepartment: { required: true, message: '请输入业务部门', trigger: 'blur' },
    contractTypeName: { required: true, message: '请输入合同类型', trigger: 'change' },
    signingDate: { required: true, message: '请选择签约日期', trigger: 'change' },
    contractPlace: { required: true, message: '请输入签约地点', trigger: 'blur' },
    signatoryName: { required: true, message: '请输入签约人', trigger: 'blur' },
    contractNatureName: { required: true, message: '请选择合同性质', trigger: 'blur' },
    dateStart: { required: true, message: '请选择开始日期', trigger: 'change' },
    dateEnd: { required: true, message: '请选择结束日期', trigger: 'change' },
    warehouseCompany: { required: true, message: '请选择仓库公司', trigger: 'change' },
    warehouseName: { required: true, message: '请选择仓库名称', trigger: 'change' },
    goodsTypeCode: {
      required: ctx.userInfo.companyCode != 'OAC24',
      message: '请选择商品类型',
      trigger: 'change',
    },
    // goodsCategoryCode: { required: true, message: '请选择商品品类', trigger: 'change' },
    customerNameOne: { required: true, message: '请选择客户1名称', trigger: 'change' },
    customerNameTwo: { required: true, message: '请选择客户2名称', trigger: 'change' },
    customerNameThree: { required: true, message: '请选择客户3名称', trigger: 'change' },
    paymentMethodName: { required: true, message: '请选择收款方式', trigger: 'change' },
    // reconciliationDate: { required: true, message: '请输入对账日', trigger: 'blur' },
    /*     taxpayerName: { required: true, message: '请输入纳税人名称', trigger: 'blur' },
    bankDeposit: { required: true, message: '请选择开户银行', trigger: 'change' },
    bankAccount: { required: true, message: '请输入银行账号', trigger: 'blur' }, */
    /* projectCode: { required: true, message: '请选择项目编号', trigger: 'change' }, */
  };
};
